<style lang="scss" scoped>
  @import "./product";
</style>

<script>
import CartService from '../cart-details/cart-details.service.js'
import { mapGetters } from 'vuex'

const cartService = new CartService()

export default {
  data: function () {
    return {
      cartService: cartService,
      minWidth: 768,
      reviewer: '',
      attribute: '',
      currentQty: 1,
      productCartQty: 1,
      incrementQty: 1,
      currency: {
        'code': 'USD',
        'symbol': '$'
      },
      cartContainer: {},
      product: {},
      showReview: false
    }
  },

  computed: {
    ...mapGetters(['currencySymbol'])
  },

  created: function () {
    this.product = this.$route.params.product
    if (this.product) {
      if (this.cartService.getCartDetails().products[this.product.productId]) {
        this.productCartQty = this.$store.state.cart.cartContainer.products[this.product.productId].cartQuantity
      }
    }
  },

  methods: {
    extractCurrentQty () {
      let temp = []
      temp.push(this.incrementQty)
      this.currentQty = temp[0]
    },

    quantityMod (quantity) {
      if (quantity === -1) {
        if (this.incrementQty > 1) {
          this.incrementQty += quantity
        }
      } else {
        this.incrementQty += quantity
      }
      this.currentQty = this.incrementQty
    },

    addToCart () {
      // Use service function to add item to cart
      // Quantity is retrieved from double bound this.incrementQty variable
      if (parseInt(this.incrementQty) > 0) {
        this.$store.dispatch('increment', {
          product: this.product,
          quantity: parseInt(this.incrementQty)
        })
        if (this.$store.state.cart.cartContainer.products[this.product.productId]) {
          this.productCartQty = this.$store.state.cart.cartContainer.products[this.product.productId].cartQuantity + this.incrementQty
        }
        this.extractCurrentQty()
      } else if (parseInt(this.incrementQty) < 0) {
        window.alert('Please enter a number that is greater than zero!')
        this.incrementQty = parseInt(this.incrementQty) * -1
      } else {
        window.alert('Please enter a number that is greater than zero!')
        this.incrementQty = 1
      }
    },

    /**
     * This method routes to Home page
     */
    homePage () {
      this.$router.push('/').catch(err => { console.error(err) })
    },

    /**
     * This method routes to Product listing Page
     */
    showAllProducts () {
      this.$router.push('/all-products').catch(err => { console.error(err) })
    }
  }
}
</script>

<template>
  <div
    class="container main mt-3 container-height bg-white"
  >
    <div v-if="product">
      <div class="row">
        <div
          class="col mt-4"
        >
          <h2 class="mb-3">
            {{ product.category }}
          </h2>
          <div class="border-dark border-top my-2" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ol class="breadcrumb bg-white p-0">
            <li
              class="breadcrumb-item text-primary btn p-0"
              @click="homePage()"
            >
              {{ $t ('label.home') }}
            </li>
            <li
              class="breadcrumb-item text-primary btn pt-0"
              @click="showAllProducts()"
            >
              {{ $t ('label.viewProducts') }}
            </li>
            <li class="breadcrumb-item p-0">
              {{ product.category }}
            </li>
          </ol>
        </div>
      </div>
      <div
        class="row"
      >
        <div class="col-md-6">
          <img
            :src="require(`@/assets/images/${product.image}`)"
            class="src-product-img mt-4"
          >
        </div>
        <div class="col-md-6">
          <h1 class="col-sm-12 col-md-12 font-weight-bold mt-4">
            {{ product.name }}
          </h1>
          <div class="col-md-12">
            <img
              class="star-rating grad"
              src="@/assets/images/transparent-stars.png"
            >
          </div>
          <div
            class="col-md-8 mt-3"
            v-html="product.description"
          />
          <div class="col-md-12 mt-3">
            <h1
              class="font-weight-bold d-inline"
              v-html="currencySymbol"
            />
            <h1 class="font-weight-bold d-inline">
              {{ (product.salePrice || product.price).toString() }}
            </h1>
          </div>
          <div class="col-md-12 mt-4">
            <h4 class="d-inline align-middle mr-1">
              {{ $t ('label.qty') }}
            </h4>
            <button
              class="btn border-dark d-inline btn-sm mr-1 btn-radius"
              @click="quantityMod(-1)"
            >
              <i class="fa fa-minus" />
            </button>
            <h5
              class="align-middle d-inline"
            >
              {{ incrementQty }}
            </h5>
            <button
              class="btn border-dark d-inline btn-sm ml-1 btn-radius"
              @click="quantityMod(1)"
            >
              <i class="fa fa-plus " />
            </button>
          </div>
          <div class="col-md-12 d-inline-flex mt-4">
            <button
              class="btn btn-primary btn-lg"
              type="btn"
              @click="addToCart()"
            >
              {{ $t ('label.addToCart') }}
            </button>
          </div>
          <div class="col-lg-6 mt-4">
            <div
              v-if=" product.features && product.features.length != 0"
            >
              <div
                :class="{'rotated' : attribute == 'features'}"
                class="src-attribute attribute"
                @click="attribute != 'features'? attribute = 'features': attribute = '';"
              >
                {{ $t ('label.features') }}
              </div>
              <div
                v-show="attribute == 'features'"
                class="mt-2"
              >
                <div
                  v-for="feature in product.features"
                  :key="feature"
                >
                  <ul class="mb-0">
                    <li>{{ feature }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              v-if="product.reviewContent && product.reviewContent.length != 0"
              class="mt-4"
            >
              <div
                :class="{'rotated' : attribute == 'reviews'}"
                class="src-attribute attribute"
                @click="attribute != 'reviews'? attribute = 'reviews': attribute = '' ;"
              >
                {{ $t ('label.reviews') }}
              </div>
              <div
                v-for="(review,index) in product.reviewContent"
                v-show="attribute == 'reviews'"
                :key="review.reviewer"
              >
                <div class="row mt-2">
                  <div class="col-md-4">
                    <img
                      class="star-rating-review grad"
                      src="@/assets/images/transparent-stars.png"
                    >
                  </div>
                  <div class="col-md-4">
                    {{ review.reviewer }}
                  </div>
                  <div class="col-md-4">
                    <a @click="showReview = !showReview">
                      <label
                        class="cursor-pointer"
                        v-html="!showReview?'Read Review':'Hide Review'"/>
                    </a>
                  </div>
                </div>
                <div
                  v-if="showReview"
                  class="d-block mb-3 ml-3"
                >
                  <div class="reviewContent">
                    {{ review.content }}
                  </div>
                </div>
                <hr v-if="(index+1 != product.reviewContent.length)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
